import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import Lightbox from 'yet-another-react-lightbox'
import { buildSharedApiUrl, buildSharedApiData, addSharedParamsToFormData } from '../../../../_helpers/SharedParams'
import QuestionModal from '../../../modals/messages/Question'

import deleteIcon from '../../../../assets/img/reservations/icons/delete.svg'
import uploadImage from '@/assets/img/reservations/icons/upload.svg'
import loader from '../../../../assets/img/loader.svg'

const MAX_VISIBLE = 12

function ReservationImages({ data }) {
    const [images, setImages] = useState({ data: [], loading: true })
    const [imageSizeError, setImageSizeError] = useState(null)
    const [lightboxSlides, setLightboxSlides] = useState([])
    const [lightboxIndex, setLightboxIndex] = useState(-1)

    const location = useLocation()
    const questionModalRef = useRef(null)

    const sharedParams = (() => {
        const sp = new URLSearchParams(location.search)
        return {
            isShared: sp.get('is_shared') === 'true',
            sharedByTenantId: sp.get('shared_by_tenant_id'),
            allowedActions: sp.get('allowed_actions'),
        }
    })()

    useEffect(() => { loadData() }, [])

    const loadData = () => {
        setImages(prev => ({ ...prev, loading: true }))
        const url = buildSharedApiUrl(`reservations/images?id=${data.id}`, sharedParams)
        Api.get(url)
            .then(res => setImages({ data: Array.isArray(res.data) ? res.data : [], loading: false }))
            .catch(() => setImages({ data: [], loading: false }))
    }

    const handleDelete = id => questionModalRef.current.open(id)

    const handleAcceptDelete = id => {
        const payload = buildSharedApiData({ id: data.id, image_id: id }, sharedParams)
        Api.post('reservations/images/delete', payload)
        setImages(prev => ({ ...prev, data: prev.data.filter(img => img.id !== id) }))
    }

    const handleFileSelect = e => {
        const files = Array.from(e.target.files)
        const oversized = files.filter(f => f.size > 1024 * 1024)
        if (oversized.length) {
            setImageSizeError(trans('messages.imageSizeExceeded', { files: oversized.map(f => f.name).join(', ') }))
            e.target.value = ''
            return
        }
        setImageSizeError(null)
        let formData = new FormData()
        formData.append('id', data.id)
        files.forEach(f => formData.append('images[]', f))
        formData = addSharedParamsToFormData(formData, sharedParams)
        Api.post('reservations/images/add', formData, {
            headers: { 'content-type': 'multipart/form-data' }
        }).then(() => {
            e.target.value = ''
            loadData()
        })
    }

    const openLightbox = idx => {
        setLightboxSlides(images.data.map(img => ({ src: img.picture })))
        setLightboxIndex(idx)
    }

    const visible = images.data.slice(0, MAX_VISIBLE)
    const hidden = images.data.length - MAX_VISIBLE

    return (
        <div className="reservation-images">
            <QuestionModal
                mainMessage={trans('headings.question4')}
                secondaryMessage={trans('subheadings.confirmDelete')}
                ref={questionModalRef}
                callback={handleAcceptDelete}
            />

            {imageSizeError && (
                <div className="alert danger" style={{ marginBottom: 10 }}>
                    {imageSizeError}
                </div>
            )}

            {images.loading ? (
                <img src={loader} alt="loading" />
            ) : visible.length > 0 ?
                <div className="res-images-grid">
                    {visible.map((image, idx) => (
                        <div key={image.id} className="res-image-item">
                            <button
                                type="button"
                                className="res-image-delete"
                                onClick={() => handleDelete(image.id)}
                            >
                                <img src={deleteIcon} alt="delete" />
                            </button>
                            <div className="res-image-thumb" onClick={() => openLightbox(idx)}>
                                <img src={image.picture} alt="" />
                                {idx === MAX_VISIBLE - 1 && hidden > 0 && (
                                    <div className="res-image-overlay">+{hidden}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                :
                <div className="alert warning" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <span style={{ flex: 1 }}> {trans("messages.noDataFound")}</span>
                </div>
            }

            <div className="upload-images" style={{
                width: 'fit-content',
            }}>
                <div className="upload-btn">
                    <img src={uploadImage} alt="Upload" />
                    <input type="file" name="images[]" multiple onChange={handleFileSelect} />
                    <div>
                        <div className="upload-title">{trans('labels.attachImages')}</div>
                        <div className="upload-subtitle">{trans('labels.allowedImageFormats')}</div>
                    </div>
                </div>
            </div>

            <Lightbox
                open={lightboxIndex >= 0}
                index={lightboxIndex}
                close={() => setLightboxIndex(-1)}
                slides={lightboxSlides}
            />
        </div>
    )
}

export default ReservationImages
